<!-- eslint-disable linebreak-style -->
<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        style="width: 100px;"
        viewBox="0 0 82.714 37.127"
    >
        <g
            id="Trazado_669"
            transform="translate(-247.811 -220.373)"
            fill="#87d3ff"
            stroke-miterlimit="10"
        >
            <path
                d="M320.988,257.5H250.03a2.216,2.216,0,0,1-2.023-3.122l6.508-14.535a2.219,2.219,0,0,0,0-1.811L248.007,223.5a2.217,2.217,0,0,1,2.023-3.123h70.959a2.217,2.217,0,0,1,2.023,1.311l7.32,16.347a2.215,2.215,0,0,1,0,1.811l-7.32,16.347A2.216,2.216,0,0,1,320.988,257.5Z"
                stroke="none"
            />
            <path
                d="M 320.9884338378906 256.4998474121094 C 321.4674682617188 256.4998474121094 321.9033203125 256.2175903320312 322.0989074707031 255.7806243896484 L 329.4186096191406 239.4335174560547 C 329.5600891113281 239.1177673339844 329.5600891113281 238.7555694580078 329.4185180664062 238.4396209716797 L 322.0988464355469 222.0926055908203 C 321.9031982421875 221.6554260253906 321.4673156738281 221.3729553222656 320.9884338378906 221.3729553222656 L 250.0298309326172 221.3729553222656 C 249.6097259521484 221.3729553222656 249.2377014160156 221.5752410888672 249.0092010498047 221.9279479980469 C 248.7806243896484 222.2807922363281 248.748046875 222.7031555175781 248.9198760986328 223.0868225097656 L 255.4284362792969 237.6227264404297 C 255.8018341064453 238.457763671875 255.8018341064453 239.4155883789062 255.4282379150391 240.2510681152344 L 248.9198455810547 254.7865753173828 C 248.7480926513672 255.1700744628906 248.7806243896484 255.5922698974609 249.0090789794922 255.9449310302734 C 249.2375640869141 256.2975769042969 249.6096038818359 256.4998474121094 250.0298309326172 256.4998474121094 L 320.9884338378906 256.4998474121094 M 320.9884338378906 257.4998474121094 L 250.0298309326172 257.4998474121094 C 248.4233551025391 257.4998474121094 247.3505401611328 255.8440704345703 248.0071868896484 254.3778533935547 L 254.5155487060547 239.8424072265625 C 254.7732391357422 239.26611328125 254.7732391357422 238.6072387695312 254.5155487060547 238.0309448242188 L 248.0071868896484 223.4954833984375 C 247.3505401611328 222.0292510986328 248.4233551025391 220.3729553222656 250.0298309326172 220.3729553222656 L 320.9884338378906 220.3729553222656 C 321.8622741699219 220.3729553222656 322.6546936035156 220.8866729736328 323.0115966796875 221.6840667724609 L 330.3312072753906 238.0309448242188 C 330.5894165039062 238.6072387695312 330.5894165039062 239.26611328125 330.3312072753906 239.8424072265625 L 323.0115966796875 256.1893005371094 C 322.6546936035156 256.9866943359375 321.8622741699219 257.4998474121094 320.9884338378906 257.4998474121094 Z"
                stroke="none"
                fill="rgba(0,136,214,0.6)"
            />
        </g>
    </svg>
</template>

<script>
export default {
    props: {
        height: {
            type: Number,
            default() {
                return 37.127;
            }
        },
        width: {
            type: Number,
            default() {
                return 82.714;
            }
        }
    }
};
</script>
